const SubscriptionStatusEnum = {
  ACTIVE: 'ACTIVE',
  FINISHED: 'FINISHED',
  CANCELED: 'CANCELED',
  TERMINATED: 'TERMINATED',
  PENDING: 'PENDING',
  };

export default SubscriptionStatusEnum;